import React, { useContext, useState, useEffect } from "react";
import { Card, Form, Input, Button, message,Select } from "antd";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { UserContext } from "../UserContext";
import './auth.css';

const Registration = () => {
	const navigate = useNavigate();
	const [role,setRole] = useState("");
	const [loading, setLoading] = useState(false);
	const [messageApi, contextHolder] = message.useMessage();
	
	const [email, setEmail] = useState("");
	const [emailError, setEmailError] = useState("");
	const [apiuri, setApiuri] = useState("");
	const { instructorapiuri, studentapiuri } = useContext(UserContext);

	useEffect(() => {
		if (role === "s") {
			setApiuri(studentapiuri);
		} else {
			setApiuri(instructorapiuri);
		}
	}, [role, studentapiuri, instructorapiuri]);

	const handleRegistration = (values) => {
	
		setLoading(true);
		if (values.password === values.confirmpassword) {
			const bodyobj = {
				email: values.email,
				password: values.password,
				firstName:values.firstname,
				lastName:values.lastName
			};

			fetch(`${apiuri}/auth/register`, {
				method: "POST",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(bodyobj),
			})
				.then((response) => {
					console.log("Response Status:", response.status);
					if (!response.ok) {
						throw new Error("Registration failed");
					}
					return response.json();
				})
				.then((data) => {
					console.log("Registration Success:", data);
					setLoading(false);
					navigate("/login");
				})
				.catch((error) => {
					console.error("Registration Error:", error);
					setLoading(false);
					messageApi.open({
						type: "error",
						content: "Registration failed. Please try again.",
					});
				});
		} else {
			messageApi.open({
				type: "warning",
				content: "Password and Confirm Password do not match",
			});
			setLoading(false);
		}
	};

	const handleEmailChange = (event) => {
		const newEmail = event.target.value;
		setEmail(newEmail);
	};

	return (
		<>
			<div className="bg signup-comp">
				<Card className="innercard">
					<div className="grid">
						<div>
							<center>
								<h1>Account Registration</h1>
							</center>
							<Form
								className="form-cont"
								layout="vertical"
								onFinish={handleRegistration}
								autoComplete="off">
								<Form.Item
									label="Role"
									name="role"
									rules={[
										{
											required: true,
											message: "Please input your username!",
										},
									]}>
									<Select
										options={[
											{
												value: "t",
												label: "Teacher",
											},
											{
												value: "s",
												label: "Student",
											},
										]}
										onChange={(e) => setRole(e)}
									/>
								</Form.Item>
								<Form.Item
									label="First Name"
									name="firstname"
									rules={[
										{
											required: true,
											message: "Please enter your first name!",
										},
										
									]}>
									<Input type="text" className="inp" />
								</Form.Item>
								<Form.Item
									label="Last Name"
									name="lastname"
									rules={[
										{
											required: true,
											message: "Please enter your last name!",
										},
										
									]}>
									<Input type="text" className="inp" />
								</Form.Item>
								<Form.Item
									label="Email"
									name="email"
									rules={[
										{
											required: true,
											message: "Please enter your email!",
										},
									]}
									validateStatus={emailError ? "error" : ""}
									help={emailError}
									hasFeedback={true}>
									<Input
										className="inp"
										value={email}
										onChange={handleEmailChange}
										type="email"
									/>
								</Form.Item>

								<Form.Item
									label="Password"
									name="password"
									rules={[
										{
											required: true,
											message: "Please enter your phone number!",
										},
										{
											min: 8,
											message: "Password must contain atleast 8 characters.",
										},
									]}>
									<Input type="password" className="inp" />
								</Form.Item>
								<Form.Item
									label="Confirm Password"
									name="confirmpassword"
									rules={[
										{
											required: true,
											message: "Please enter your phone number!",
										},
									]}>
									<Input className="inp" type="password" />
								</Form.Item>
								<div className="adjust">
									<label htmlFor="Login">Already have an account? &nbsp;</label>
									<Link id="Login" to="/login" className="a">
										Log in
									</Link>
								</div>
								<br></br>

								<Form.Item className="sub-btn">
									<Button type="primary" className="btn1" htmlType="submit">
										Sign Up
									</Button>
								</Form.Item>
							</Form>
						</div>
					</div>
				</Card>
			</div>

			{contextHolder}
		</>
	);
};

export default Registration;
